import { render, staticRenderFns } from "./qyQA.vue?vue&type=template&id=fbab83b0&scoped=true"
import script from "./qyQA.vue?vue&type=script&lang=js"
export * from "./qyQA.vue?vue&type=script&lang=js"
import style0 from "./qyQA.vue?vue&type=style&index=0&id=fbab83b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbab83b0",
  null
  
)

export default component.exports